import React from "react";
import { Link } from "react-router-dom";

function NotFoundPage() {
    return (
        <div>
            <h2>No fit found</h2>
            <br />
            <p>No fitting page found </p> 
            <br />
            <p>No se encontro la pagina, por favor revisa la URL e intenta de nuevo. </p>
            <br />
            <p>
                <Link to="/" className="btn btn-primary">
                    Back to Home
                </Link>
            </p>
        </div>
    );
}
export default NotFoundPage;
